<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t0">Praise for </span><span class="t1">D.W. M</span><span class="t2">ARCHWELL</span></p>
<p class="p1"><span class="t0"> </span></p>
<p class="p2"><span class="t1"><i>Good to Know</i></span></p>
<p class="p3"><span class="t3"> </span></p>
<p class="p3">“It definitely appealed to the romantic in me.”</p>
<p class="p4">—Book Wenches</p>
<p class="p3">“I was completely enchanted.”</p>
<p class="p4">—eHarlequin</p>
<p class="p3">“A sweet romance.”</p>
<p class="p4">—Elisa Rolle</p>
<p class="p3"><span class="t3"> </span></p>
<p class="p2"><span class="t1"><i>An Earlier Heaven</i></span></p>
<p class="p3"><span class="t3"> </span></p>
<p class="p3">“Marchwell has done yet another fantastic job with creating a story designed to draw the reader in and keep you compelled until the final sentence.”</p>
<p class="p4">—Literary Nymphs</p>
<p class="p3">“…a beautiful reminder to count your blessings no matter how big or small, and it will linger in your heart and mind long after the last page is turned.”</p>
<p class="p4">—Whipped Cream Reviews</p>
<p class="p3"><span class="t3"> </span></p>
<p class="p2"><span class="t1"><i>Sins of the Father</i></span></p>
<p class="p3"><span class="t3"> </span></p>
<p class="p3">“The characters are strongly written and are sure to pull at the heartstrings of the readers.”</p>
<p class="p5">—Rainbow Reviews</p>
<p class="p3">“A thought-provoking and touching story of love and second chances.” </p>
<p class="p4">—Book Wenches</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?53fc3ad6